import { styled } from 'styled-components';
import { IArticlesRecommended1, defaultParams } from './params';

import getBackgroundImageStyles from '../../../utils/getBackgroundImageStyles';

const Styles = styled.div<{
  $config: IArticlesRecommended1;
}>`
  .articles-recommended {
    padding: 25px 20px 40px;
    margin-bottom: 60px;
    background: ${({ $config: styles }) => getBackgroundImageStyles(styles.backgroundImage)};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: ${({ $config: styles }) => styles.borderRadius};
    box-shadow: ${({ $config: styles }) => styles.boxShadow};
    border: ${({ $config: styles }) => styles.border};
    overflow: hidden;

    &-header {
      color: ${({ $config: styles }) => styles.group_header.color};
      font-family: ${({ $config: styles }) => styles.group_header.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_header.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_header.fontSize};
      line-height: ${({ $config: styles }) => styles.group_header.lineHeight};
      border-bottom: ${({ $config: styles }) => styles.group_header.borderBottom};
      text-align: ${({ $config: styles }) => styles.group_header.textAlign};
      padding-bottom: ${({ $config: styles }) => (styles.group_header.borderBottom === 'none' ? 0 : '12px')};
      margin-bottom: 40px;
    }

    &-article {
      position: relative;
      display: grid;
      grid-template-columns: 90px 1fr;
      gap: 15px;

      &:nth-child(n) {
        padding-bottom: 25px;
        border-bottom: ${({ $config: styles }) => styles.group_header.borderBottom};
      }
      &:last-child {
        padding-bottom: 0;
        border-bottom: none;
      }
      &-image-wrapper {
        width: 90px;
        height: 90px;
        border-radius: ${({ $config: styles }) => styles.group_article.group_image.borderRadius};
        border: ${({ $config: styles }) => styles.group_article.group_image.border};
        overflow: hidden;
        &:hover {
          cursor: pointer;
          transition: 0.3s all ease-in;
        }
      }
      &-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &-title {
        margin-bottom: 0;

        a {
          color: ${({ $config: styles }) => styles.group_article.group_header.color};
          font-size: ${({ $config: styles }) => styles.group_article.group_header.fontSize};
          font-family: ${({ $config: styles }) => styles.group_article.group_header.fontFamily};
          font-style: ${({ $config: styles }) => styles.group_article.group_header.fontStyle};
          font-weight: ${({ $config: styles }) => styles.group_article.group_header.fontWeight};
          line-height: ${({ $config: styles }) => styles.group_article.group_header.lineHeight};
          text-decoration: ${({ $config: styles }) => styles.group_article.group_header.textDecoration};
          &:hover {
            color: ${({ $config: styles }) => styles.group_article.group_header.hover_color};
            text-decoration: ${({ $config: styles }) => styles.group_article.group_header.hover_textDecoration};
            cursor: pointer;
            transition: 0.2s all ease-in;
          }
        }
      }
      &-description {
        grid-column: 1 / span 2;
        color: ${({ $config: styles }) => styles.group_article.group_content.color};
        font-size: ${({ $config: styles }) => styles.group_article.group_content.fontSize};
        font-family: ${({ $config: styles }) => styles.group_article.group_content.fontFamily};
        font-style: ${({ $config: styles }) => styles.group_article.group_content.fontStyle};
        font-weight: ${({ $config: styles }) => styles.group_article.group_content.fontWeight};
        line-height: ${({ $config: styles }) => styles.group_article.group_content.lineHeight};
      }
    }

    &-list {
      display: grid;
      -ms-grid-columns: 1fr;
      gap: 25px;
      @media (min-width: ${({ theme }) => theme.breakpoint.md}) {
        grid-template-columns: 1fr 1fr;
        .articles-recommended-article {
          &:nth-last-child(-n + 2) {
            padding-bottom: 0;

            &::after {
              display: none;
            }
          }
        }
      }
      @media (min-width: ${({ theme }) => theme.breakpoint.lg}) {
        grid-template-columns: 1fr;
        .articles-recommended-article {
          &:nth-last-child(2) {
            padding-bottom: 25px;
            &::after {
              display: block;
            }
          }
        }
      }
    }
  }
`;

export default Styles;
